function FormCtrl($scope, $controller,$location,$timeout, $state){

    $scope.formData = {};
    
    var current = $scope.getCurrent();

    var entity = current.modelKey.replace("Id","");

    $scope.validateOnServer = [];
    $scope.validateOnServer.push('name');
    
    if($state.current.newItem){
       $scope.formType = "new";
       entity = $state.current.type.toLowerCase();
    }

    var requestData = {};
    requestData[current.modelKey] = current.modelId;
    requestData.newItem = $state.current.newItem;
    requestData.type = $state.current.type;
    requestData.accountId = $state.params.accountId;

    store.fetch({
        path: '/show',
        queryParams: requestData,
        filter: true,
        success: function(data) {
            if($scope.formatData){
                $scope.formatData(data);
            }
            if($state.current.newItem){
                $scope.formData = data;
            }
            $scope[entity] = data;
            $scope.cur = data;

            if($scope.afterFetch && typeof $scope.afterFetch === "function"){
                $scope.afterFetch();
            }
        }
    });

}

